// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__lOBar","search":"Settings_search__2NLgP","filter":"Settings_filter__3YYFP"};